export default __webpack_public_path__ + "static/media/details3.d05d3d02.jpg";